
/****
 *  扩展函数执行完后的处理实现
 *  应用场景：在调用第三方js类库时，期望不影响其内部函数的结构和执行逻辑同时能自定义自己的业务在内时可以使用。
 *  好处： 1.完全和第三方js类库分离，不破坏其内部代码的结构和逻辑同时可以修改内部的执行逻辑;
 *        2.不影响后续的第三方类库的升级和使用。
 *        3。改完的新逻辑在全局范围内都有效。
 ****/

Function.prototype.after = function(afterfn){
  let _this = this; // 保存原函数的引用
  return function(){ // 返回包含了原函数和新函数的"代理"函数
    let ret = _this.apply(this,arguments)  //执行原函数且保证 this 不被劫持
    afterfn.apply(this,arguments); // 执行新函数，且保证 this 不被劫持，新函数接受的参数
    return ret; //返回原函数的执行结果
  }
};

window.onload = window.onload||function(){}.after(function(){
  try{
    /*******修复绘制线或面不能同步漫游地图的问题********/
    L.Draw.Polyline.prototype.addHooks = L.Draw.Polyline.prototype.addHooks.after(function(){
      this._mouseMarker._map.off("touchstart");
      this._mouseMarker._map.on("click",this._onTouch,this);
    });
  }catch(e){console.log(e)}
});




// WEBPACK FOOTER //
// ./src/utils/PrototypeExtend.js